"use client";
import get_smpUUID_helper from '@/app/api/data/members/smpUUID/get_smpUUID_helper';
import { useFasterUrlUpdate } from '@/app/hooks/useFastUrlUpdate';
import { api_getMinecraftRig, cn } from '@/lib/utils';
import ImageNext from 'next/image';
import { ReactNode, useEffect, useState } from 'react';
import useSWR, { SWRConfiguration_Custom } from 'swr';
import "./TimeTravelLayout.css";

function TimeTravelLayout({ children }: { children: ReactNode }) {
    const { fastUrl } = useFasterUrlUpdate()
    const [oldPath, setOldPath] = useState(fastUrl);

    //extract creator name form url
    const [, , creatorName] = fastUrl.split("/");
    const { data: creatorUUID } = useSWR<Awaited<ReturnType<typeof get_smpUUID_helper>>>(creatorName ? `/api/data/members/smpUUID?creator=${creatorName}` : null, {
        "keepPreviousData": true,
        "refreshInterval": 0,//prevent refresh (not needed)

        /** remove revalidation as this data is not likely to change mid page life */
        "shouldRetryOnError": false,
        "revalidateOnReconnect": false,
    } as SWRConfiguration_Custom);

    const uuid = (!creatorUUID || ("error" in creatorUUID)) ? "OlympicAngel" : creatorUUID.uuid;
    const miniME_src = api_getMinecraftRig(uuid, 0.3, "mojavatar");

    const [animating, setAnimating] = useState(false);

    useEffect(() => {
        //if same path ignore OR if already animating
        if (fastUrl == oldPath || animating)
            return;
        //update path 
        setOldPath(fastUrl)

        //extract season names
        const [, , , currentSeason] = fastUrl.split("/");
        const [, , , nextSeason] = oldPath.split("/");

        //if no season name - no animation
        if (currentSeason == nextSeason ||
            !currentSeason || !nextSeason) //if navigated from / to all season
            return;

        if (Math.random() > 0.1)
            return

        //start animating
        setAnimating(true)

    }, [fastUrl, oldPath, animating])

    //preload images
    useEffect(() => {
        // Preload player image
        const img = new Image();
        img.src = miniME_src;
        img.onload = () => { };

        // Preload player image
        const bed_img = new Image();
        bed_img.src = "/_next/image?url=/assets/PinkBed.webp&w=256&q=90";
        bed_img.onload = () => { };

        // Preload player image
        const bedrock_img = new Image();
        bedrock_img.src = "/_next/image?url=/assets/bedrock.webp&w=96&q=70";
        bedrock_img.onload = () => { };
    }, [miniME_src])

    return (
        <>
            { children }
            <div className={ cn("main", !animating && "invisible hidden") } onAnimationEnd={ () => { setAnimating(false) } }>
                <div>
                    <ImageNext src={ miniME_src } loading="eager" fetchPriority='high' alt='דמות מיינקראפט' fill unoptimized />
                </div>
            </div>
        </>
    )
}

export default TimeTravelLayout